import { render } from "./DynamicPlayerSecurity.vue?vue&type=template&id=6fd84bf1"
import script from "./DynamicPlayerSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicPlayerSecurity.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DynamicPlayer/DynamicPlayerSecurity.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fd84bf1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fd84bf1', __exports__)) {
    api.reload('6fd84bf1', __exports__)
  }
  
  module.hot.accept("./DynamicPlayerSecurity.vue?vue&type=template&id=6fd84bf1", () => {
    api.rerender('6fd84bf1', render)
  })

}


export default __exports__